import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { GlobalAppDataStorageService } from "infra/storage";
import { Controller, useFormContext } from "react-hook-form";
import RelocationField from "./relocation/RelocationField";

export default function LookingFor({ data }) {
    const {
        control,
    } = useFormContext();

    const {
        relocation,
    } = data;
    
    const workingModelsOptions = GlobalAppDataStorageService.getWorkingModels();
    const jobTypesOptions = GlobalAppDataStorageService.getJobTypes();
    const industriesOptions = GlobalAppDataStorageService.getIndustries();
    const jobFunctionsOptions = GlobalAppDataStorageService.getJobFunctions();
    const occupationsOptions = GlobalAppDataStorageService.getOccupations();
    const companySizeOptions = GlobalAppDataStorageService.getCompanySizes();
    const skillsOptions = GlobalAppDataStorageService.getHardSkills();
    
    return (
        <Box component="section" sx={{ mb: 4, width: "100%", display: "grid", gap: 2, gridTemplateColumns: "repeat(4, 1fr)" }}>
            <Typography variant="h6" gutterBottom sx={{ gridColumn: "span 4" }}>
                Looking For
            </Typography>
            <Controller
                name="lookingFor.workingModels"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="lookingFor.workingModels"
                        autoComplete
                        fullWidth
                        multiple
                        options={workingModelsOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(event, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Working Model"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="lookingFor.jobTypes"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="lookingFor.jobTypes"
                        autoComplete
                        multiple
                        fullWidth
                        options={jobTypesOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(_, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Job Type"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="lookingFor.industries"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="lookingFor.industries"
                        autoComplete
                        multiple
                        fullWidth
                        options={industriesOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(_, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Preferred Industries"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="lookingFor.jobFunctions"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="lookingFor.jobFunctions"
                        autoComplete
                        multiple
                        fullWidth
                        options={jobFunctionsOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(_, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Preferred Job Function"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="lookingFor.occupations"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="lookingFor.occupations"
                        autoComplete
                        multiple
                        fullWidth
                        options={occupationsOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(_, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Preferred Occupations"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="lookingFor.hardSkills"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="lookingFor.hardSkills"
                        autoComplete
                        multiple
                        fullWidth
                        options={skillsOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(_, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Preferred Skills"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="lookingFor.companySizes"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="lookingFor.companySizes"
                        autoComplete
                        multiple
                        fullWidth
                        options={companySizeOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(_, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Company Size"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <RelocationField savedRelocationData={relocation} />
        </Box>
    );
}
